(function(){
  var VERSION='2.4.1',lastOpener=null,downOnBackdrop=false;
  window.CocoRockQuickViewVersion=VERSION;

  function unlockPage(){
    if(!document.querySelector('.cr-qv[open]')&&!document.querySelector('[data-cr-home-quick]:not([hidden])'))document.documentElement.style.overflow='';
  }

  function restoreOpener(){
    if(lastOpener&&document.contains(lastOpener))lastOpener.focus();
    lastOpener=null;
  }

  /* Tabela nutricional: mesma fonte da seção "CR · Descrição + Tabela" ([data-cr-nutri-data]).
     Usa a da própria página quando existe (combo, produto); senão lê a da página do produto, uma vez por produto. */
  var nutriCache={};
  function nutriFrom(scope,handle){
    var out=[],seen={};
    scope.querySelectorAll('[data-cr-nutri-data]').forEach(function(node){
      var list;try{list=JSON.parse(node.textContent)}catch(error){return}
      (list||[]).forEach(function(entry){var key=String(entry.flavor||'').toLowerCase();if(entry.handle===handle&&!seen[key]){seen[key]=true;out.push(entry)}});
    });
    return out;
  }
  function loadNutri(handle){
    if(nutriCache[handle])return nutriCache[handle];
    var local=nutriFrom(document,handle);
    if(local.length)return(nutriCache[handle]=Promise.resolve(local));
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    nutriCache[handle]=fetch(root+'products/'+encodeURIComponent(handle),{credentials:'same-origin'})
      .then(function(response){if(!response.ok)throw new Error(response.status);return response.text()})
      .then(function(html){return nutriFrom(new DOMParser().parseFromString(html,'text/html'),handle)})
      .catch(function(){delete nutriCache[handle];return[]});
    return nutriCache[handle];
  }
  function el(tag,className,text){var node=document.createElement(tag);if(className)node.className=className;if(text!=null)node.textContent=text;return node}
  function renderNutri(dialog){
    var box=dialog.querySelector('[data-cr-qv-nutri]');
    if(!box)return;
    var list=box.crNutri||[];
    if(!list.length){box.hidden=true;return}
    var pressed=dialog.querySelector('[data-cr-qv-variant][aria-pressed="true"]');
    var wanted=pressed?pressed.textContent.trim().toLowerCase():'';
    var match=list.find(function(entry){return String(entry.flavor||'').trim().toLowerCase()===wanted});
    /* sabor sem tabela cadastrada: esconde em vez de mostrar a de outro sabor (ingredientes e alérgicos mudam) */
    if(!match&&dialog.querySelectorAll('[data-cr-qv-variant]').length>1){box.hidden=true;return}
    var data=match||list[0];
    box.textContent='';
    var title=el('h4','cr-qv__nutri-title','Ingredientes e tabela nutricional');
    if(list.length>1&&data.flavor)title.appendChild(el('span','cr-qv__nutri-flavor',' · '+data.flavor));
    box.appendChild(title);
    if(data.desc)box.appendChild(el('p','cr-qv__nutri-desc',data.desc));
    if(data.ing){var ing=el('p','cr-qv__nutri-ing');ing.appendChild(el('b',null,'Ingredientes: '));ing.appendChild(document.createTextNode(data.ing));box.appendChild(ing)}
    if(data.portion)box.appendChild(el('p','cr-qv__nutri-portion',data.portion));
    var table=el('table','cr-qv__nutri-table'),head=el('thead'),row=el('tr'),body=el('tbody');
    ['Nutriente','Porção','%VD*'].forEach(function(label){row.appendChild(el('th',null,label))});
    head.appendChild(row);table.appendChild(head);
    (data.rows||[]).forEach(function(item){
      var label=String(item[0]||''),sub=/^(&nbsp;)+/.test(label),tr=el('tr',sub?'is-sub':null);
      tr.appendChild(el('td',null,label.replace(/^(&nbsp;)+/,'')));
      tr.appendChild(el('td',null,item[1]||'—'));
      tr.appendChild(el('td',null,item[2]===''||item[2]==null?'—':item[2]+'%'));
      body.appendChild(tr);
    });
    table.appendChild(body);box.appendChild(table);
    if(data.claims)box.appendChild(el('p','cr-qv__nutri-claims',data.claims));
    if(data.aviso)box.appendChild(el('p','cr-qv__nutri-aviso',data.aviso));
    box.appendChild(el('p','cr-qv__nutri-note','*Percentual de valores diários fornecidos pela porção.'));
    box.hidden=false;
  }
  function prepareNutri(dialog){
    var box=dialog.querySelector('[data-cr-qv-nutri]');
    if(!box||box.dataset.crNutriLoaded)return;
    box.dataset.crNutriLoaded='true';
    loadNutri(box.getAttribute('data-cr-qv-nutri')).then(function(list){
      box.crNutri=list;
      if(!list.length)delete box.dataset.crNutriLoaded;
      renderNutri(dialog);
    });
  }

  function openDialog(id,opener){
    var dialog=document.getElementById(id);
    if(!dialog)return;
    lastOpener=opener||document.activeElement;
    if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','');
    document.documentElement.style.overflow='hidden';
    init(dialog);
    prepareNutri(dialog);
    var close=dialog.querySelector('[data-cr-qv-close]');if(close)window.requestAnimationFrame(function(){close.focus()});
  }

  function closeDialog(dialog){
    if(!dialog)return;
    if(typeof dialog.close==='function')dialog.close();else dialog.removeAttribute('open');
    unlockPage();
    restoreOpener();
  }

  function galleryParts(node){
    var gallery=node&&node.closest?node.closest('[data-cr-qv-gallery]'):null;
    return gallery?{
      gallery:gallery,
      viewport:gallery.querySelector('[data-cr-qv-viewport]'),
      slides:[].slice.call(gallery.querySelectorAll('[data-cr-qv-slide]')),
      thumbs:[].slice.call(gallery.querySelectorAll('[data-cr-qv-thumb]')),
      prev:gallery.querySelector('[data-cr-qv-prev]'),
      next:gallery.querySelector('[data-cr-qv-next]')
    }:null;
  }

  function current(parts){
    if(!parts||!parts.viewport)return 0;
    var value=parseInt(parts.viewport.dataset.crGalleryIndex,10);
    return Number.isFinite(value)?value:0;
  }

  function setIndex(parts,index,focusThumb){
    if(!parts||!parts.slides.length)return;
    var length=parts.slides.length;
    index=((index%length)+length)%length;
    parts.viewport.dataset.crGalleryIndex=String(index);
    parts.slides.forEach(function(slide,i){
      var active=i===index;
      slide.hidden=!active;
      slide.classList.toggle('is-active',active);
      slide.setAttribute('aria-hidden',active?'false':'true');
      slide.style.transform='';
    });
    parts.thumbs.forEach(function(thumb,i){
      var active=i===index;
      thumb.classList.toggle('is-active',active);
      thumb.setAttribute('aria-current',active?'true':'false');
      if(active&&focusThumb){var strip=thumb.parentElement;if(strip&&strip.scrollTo)strip.scrollTo({left:thumb.offsetLeft-(strip.clientWidth-thumb.clientWidth)/2,behavior:'smooth'})}
    });
    if(parts.prev)parts.prev.disabled=length<2;
    if(parts.next)parts.next.disabled=length<2;
    [parts.slides[index],parts.slides[(index+1)%length]].forEach(function(slide,position){
      if(!slide)return;var media=slide.querySelector('img,video,model-viewer');if(!media){slide.classList.add('is-media-ready');return}
      var owner=slide.closest('[data-cr-qv]');if(position===0&&media.tagName==='IMG'&&(!owner||owner.open))media.loading='eager';
      function ready(){slide.classList.add('is-media-ready');if(position===0&&parts.viewport)parts.viewport.setAttribute('aria-busy','false')}
      var loaded=media.tagName==='IMG'?media.complete:(media.tagName==='VIDEO'?media.readyState>=1:media.loaded===true);
      if(position===0&&parts.viewport)parts.viewport.setAttribute('aria-busy',loaded?'false':'true');
      if(loaded)ready();else{media.addEventListener(media.tagName==='VIDEO'?'loadedmetadata':'load',ready,{once:true});media.addEventListener('error',ready,{once:true})}
      if(typeof media.decode==='function')media.decode().then(ready).catch(function(){});
    });
  }

  function normalizeUrl(value){
    if(!value)return'';
    try{var url=new URL(value,window.location.origin);return url.pathname.replace(/_[0-9]+x[0-9]*(?=\.[a-z]+$)/i,'')}catch(error){return value.split('?')[0]}
  }

  function goToMedia(scope,mediaId,imageUrl){
    var gallery=scope.querySelector('[data-cr-qv-gallery]');
    if(!gallery)return;
    var parts=galleryParts(gallery),wantedImage=normalizeUrl(imageUrl),index=-1;
    parts.slides.some(function(slide,i){
      var idMatch=mediaId&&slide.dataset.mediaId===mediaId;
      var imageMatch=wantedImage&&normalizeUrl(slide.dataset.imageUrl)===wantedImage;
      if(idMatch||imageMatch){index=i;return true}return false;
    });
    if(index>=0)setIndex(parts,index,true);
  }

  function init(scope){
    var dialogs=[];
    if(scope&&scope.matches&&scope.matches('[data-cr-qv]'))dialogs.push(scope);
    (scope||document).querySelectorAll('[data-cr-qv]').forEach(function(dialog){dialogs.push(dialog)});
    dialogs.forEach(function(dialog){if(dialog.dataset.crDialogReady)return;dialog.dataset.crDialogReady='true';dialog.addEventListener('close',function(){unlockPage();restoreOpener()})});
    (scope||document).querySelectorAll('[data-cr-qv-gallery]').forEach(function(gallery){
      var parts=galleryParts(gallery),active=parts.slides.findIndex(function(slide){return slide.classList.contains('is-active')});
      setIndex(parts,active>=0?active:0,false);
      gallery.dataset.crGalleryReady=VERSION;
    });
  }

  function onClick(event){
    var opener=event.target.closest('[data-cr-qv-open]');
    if(opener){event.preventDefault();openDialog(opener.getAttribute('data-cr-qv-open'),opener);return}
    var closer=event.target.closest('[data-cr-qv-close]');
    if(closer){closeDialog(closer.closest('[data-cr-qv]'));return}
    var thumb=event.target.closest('[data-cr-qv-thumb]');
    if(thumb){event.preventDefault();setIndex(galleryParts(thumb),parseInt(thumb.dataset.index,10)||0,true);return}
    var arrow=event.target.closest('[data-cr-qv-prev],[data-cr-qv-next]');
    if(arrow){event.preventDefault();var parts=galleryParts(arrow),delta=arrow.hasAttribute('data-cr-qv-next')?1:-1;setIndex(parts,current(parts)+delta,true);return}
    var variant=event.target.closest('[data-cr-qv-variant]');
    if(variant&&!variant.disabled){
      event.preventDefault();
      var dialog=variant.closest('[data-cr-qv]');
      dialog.querySelectorAll('[data-cr-qv-variant]').forEach(function(item){item.setAttribute('aria-pressed',item===variant?'true':'false')});
      var price=dialog.querySelector('[data-cr-qv-price]');
      if(price&&variant.dataset.priceMoney)price.textContent=variant.dataset.priceMoney;
      goToMedia(dialog,variant.dataset.mediaId,variant.dataset.imageUrl);
      renderNutri(dialog);
      var comboLink=dialog.querySelector('a.cr-qv__primary');
      if(comboLink&&variant.dataset.variantId){try{var url=new URL(comboLink.getAttribute('href'),window.location.origin);url.searchParams.set('variant',variant.dataset.variantId);comboLink.setAttribute('href',url.pathname+url.search)}catch(error){}}
      return;
    }
    var backdrop=event.target.matches&&event.target.matches('[data-cr-qv]')?event.target:null;
    if(backdrop&&downOnBackdrop)closeDialog(backdrop);
  }

  function onPointerDown(event){
    downOnBackdrop=!!(event.target.matches&&event.target.matches('[data-cr-qv]'));
    var viewport=event.target.closest('[data-cr-qv-viewport]');
    if(!viewport||(event.pointerType==='mouse'&&event.button!==0))return;
    if(event.pointerType==='mouse')event.preventDefault();
    var parts=galleryParts(viewport);
    if(!parts||parts.slides.length<2)return;
    var startX=event.clientX,lastX=startX,moved=false,active=parts.slides[current(parts)];
    viewport.classList.add('is-dragging');
    if(viewport.setPointerCapture)viewport.setPointerCapture(event.pointerId);
    function move(moveEvent){
      lastX=moveEvent.clientX;
      var delta=lastX-startX;
      if(Math.abs(delta)>5)moved=true;
      if(active)active.style.transform='translateX('+delta+'px)';
    }
    function end(endEvent){
      viewport.removeEventListener('pointermove',move);
      viewport.removeEventListener('pointerup',end);
      viewport.removeEventListener('pointercancel',end);
      viewport.classList.remove('is-dragging');
      if(active)active.style.transform='';
      if(viewport.hasPointerCapture&&viewport.hasPointerCapture(endEvent.pointerId))viewport.releasePointerCapture(endEvent.pointerId);
      var delta=lastX-startX;
      if(Math.abs(delta)>38)setIndex(parts,current(parts)+(delta<0?1:-1),true);
      if(moved){viewport.dataset.crDragged='true';setTimeout(function(){delete viewport.dataset.crDragged},0)}
    }
    viewport.addEventListener('pointermove',move);
    viewport.addEventListener('pointerup',end);
    viewport.addEventListener('pointercancel',end);
  }

  function suppressDraggedClick(event){
    var viewport=event.target.closest&&event.target.closest('[data-cr-qv-viewport]');
    if(viewport&&viewport.dataset.crDragged){event.preventDefault();event.stopPropagation()}
  }

  if(window.CocoRockQuickViewClick)document.removeEventListener('click',window.CocoRockQuickViewClick);
  if(window.CocoRockQuickViewPointer)document.removeEventListener('pointerdown',window.CocoRockQuickViewPointer);
  if(window.CocoRockQuickViewDragged)document.removeEventListener('click',window.CocoRockQuickViewDragged,true);
  window.CocoRockQuickViewClick=onClick;
  window.CocoRockQuickViewPointer=onPointerDown;
  window.CocoRockQuickViewDragged=suppressDraggedClick;
  document.addEventListener('click',onClick);
  document.addEventListener('pointerdown',onPointerDown);
  document.addEventListener('click',suppressDraggedClick,true);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
})();
